module.exports = __webpack_public_path__ + "media/soundtrack.a6808f8f.mp3";